/**
 *  Checkbox script file
**/

export default {
  name: 'Checkbox',
  mixins: [],
  components: {},
  props: {
    value: {
      type: Boolean,
      required: true
    },
    label: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'checkbox'
    }
  },
  watch: {
    value () {
      this.currentState = this.value
    }
  },
  data () {
    return {
      currentState: false
    }
  },
  mounted () {
    this.currentState = this.value
  },
  computed: {},
  methods: {
    toggle (event) {
      event.preventDefault()
      if (this.disabled) {
        return false
      }

      const checked = this.currentState !== true
      this.currentState = checked
      this.$emit('input', checked)
    }
  }
}
